(function($) {

  if ($('body.is-new-details, body.is-used-details').length) {

    var closeBtnLabel = "Close";

    if($('.lang-fr')){
      closeBtnLabel = "Fermer";
    }

    // Set product value if available
    var product_price;

    // Define default tax_rate from QC
    var tax_rate = 0.14975;;

    if ($('body.is-new-details').length || $('body.is-used-details').length) {
      $('#trigger-form-calculator').click(function(){
        product_price = parseInt($('[data-price]').text().replace(/\D/g,''));
        reset_form();
      });
    }

    function reset_form() {
      $('#calculatorForm #taxes-value').val('');
      $('#calculatorForm #financed-amount').val('');
      $('#calculatorForm #total-amount').val('');

      if (product_price > 0) {
        $('#desired-product-value').val(product_price);
      }
    }   

    // Total sale value
    function get_sale_value() {
      // Get value of product + financial products
      var desired_product_value = parseInt($('#desired-product-value').val());
      // var financial_products_value = parseInt($('#financial-products-value').val());
      // var total_sale_value = desired_product_value + financial_products_value;
      var total_sale_value = desired_product_value;

      return total_sale_value;
    }

    // Taxes
    function get_taxes() {
      // Default QC tax rate
      if( typeof oTaxes === 'object' ) {
        var sProvince = ( $('#trigger-form-calculator').length ? $('#trigger-form-calculator').attr('data-province') : 'Québec' );
        tax_rate = oTaxes[sProvince];
      }

      var sale_value = get_sale_value();
      var taxes_value = tax_rate * sale_value;

      // Round
      taxes_value = Number(taxes_value.toFixed(2));

      return taxes_value;
    }

    // Financed amount
    function get_financed_amount() {
      var sale_value = get_sale_value();
      var taxes_value = get_taxes();
      var trade_in_value = parseInt($('#trade-in-value').val());

      var financed_amount = (sale_value + taxes_value) - trade_in_value;

      // Round
      financed_amount = Number(financed_amount.toFixed(2));

      return financed_amount;
    }

    // Total payment amount
    function get_payment_amount() {
      interest_rate = parseFloat($('#interest-rate').val());
      loanAmt = get_financed_amount();
      intRate = interest_rate / 100;
      payFreq = parseFloat($('#payment-period').val());
      amortization = parseInt($('#amortization').val());
      totalPayments = amortization / payFreq;

      payAmt = (loanAmt*(intRate*payFreq/12)*Math.pow((1+(intRate*payFreq/12)),totalPayments))/(Math.pow((1+(intRate*payFreq/12)),totalPayments)-1);
      payAmt = Math.round(payAmt *100) /100;

      return payAmt;
    }


    function calculate_total() {
      // Check if product value exist
      if (!$('#desired-product-value').val().length) {
        $('#desired-product-value').addClass('error');
        $('.error-msg').show();
        return;
      } else {
        $('#desired-product-value').removeClass('error');
        $('.error-msg').hide();
      }

      // Set trade-in value to 0 if field not filled
      if (!$('#trade-in-value').val().length) {
        $('#trade-in-value').val(0);
      }

      // Calculate payements
      $('#taxes-value').val(get_taxes());
      $('#financed-amount').val(get_financed_amount());
      $('#total-amount').val(get_payment_amount());
    }

    // Calculator popup form layout
    $('.fancybox[href="#hidden-form-calculator"]').fancybox({
      maxWidth: 800,
      padding: 0,
      tpl: {
        closeBtn: '<a title="'+closeBtnLabel+'" class="fancybox-item fancybox-close" href="javascript:;"></a>',
      },
      afterLoad: function() {
        
      },
      afterShow: function() {
        $('#calculate').click(function() {
          calculate_total();
        });
      }
    });
  }

})(jQuery); // Fully reference jQuery after this point.